import {forwardRef} from "react";
import type {AppSelectComponent} from "../Base/SelectBase.types";
import type {AppSelectProps} from "./Select.types";
import {AppSelectBase} from "../Base/SelectBase";

export const AppSelect = forwardRef<AppSelectComponent, AppSelectProps>(
  (props, ref) => {
  return <AppSelectBase {...props} ref={ref}/>;
});
